import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {faCircleCheck, faCircleXmark, faFile, faXmark} from '@fortawesome/pro-solid-svg-icons';

/** Daten des Testlauf-Toasts (über `BicToastService.showComponent(..., {data})`). */
export interface RuleTestToastData {
  status: 'COMPLETED' | 'FAILED';
  /** „GL_3_B · ASR A3.5 Raumtemperatur" – eigene Zeile, damit der Dateiname nicht mit abgeschnitten wird. */
  ruleLabel: string;
  /** „Raumbuch_EG.pdf" (bei Cross Check mehrere, kommagetrennt). */
  fileNames: string;
  /** „Ergebnis ansehen" – öffnet das Popup des Editors bzw. navigiert dorthin. */
  open: () => void;
}

/**
 * Toast „Testlauf abgeschlossen / fehlgeschlagen" mit Link zum Ergebnis.
 *
 * Eigene Komponente, weil der Bibliotheks-Toast nur Text kann. Optik wie `lib-bic-toast`
 * (Hintergrund je Typ, `shadow-full`, X rechts). Geschlossen wird er vom Toast-Container: ein Klick
 * irgendwo auf den Toast – auch auf den Link – entfernt ihn.
 */
@Component({
  selector: 'app-rule-test-toast',
  standalone: true,
  imports: [FaIconComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './rule-test-toast.component.html',
})
export class RuleTestToastComponent {
  @Input() data: RuleTestToastData | null = null;

  protected readonly faCircleCheck = faCircleCheck;
  protected readonly faCircleXmark = faCircleXmark;
  protected readonly faXmark = faXmark;
  protected readonly faFile = faFile;

  get failed(): boolean {
    return this.data?.status === 'FAILED';
  }

  openResult(): void {
    this.data?.open();
  }
}
